import log from 'client/lib/log';

import {
  SR_API_ACTION_SANITIZE_USER_DATA,
} from 'api/actionTypes';

export default async function sanitizeUserData({ apiClient }) {
  let result;
  try {
    result = await apiClient.post(SR_API_ACTION_SANITIZE_USER_DATA);
  }
  catch (error) {
    log.error(error);
  }
  return result;
}
